module.exports = __webpack_public_path__ + "img/prize_bg.fec6d274.png";